// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--prev-head-main-container h6 {
    margin: 0;
}

.scl--prev-head-const-bread-sec-on {
    width: 100%;
    height: 21px;
    display: flex;
    gap: 3px;
}

.scl--prev-head-const-bread-sec-on button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px
}

.scl--prev-head-const-bread-sec-on span {
    color: rgba(138, 139, 143, 1);
    font-size: 14px;
    display: flex;
    align-items: center;
}

.scl--prev-head-const-bread-sec-on h6 {
    color: rgba(138, 139, 143, 1);
    font-weight: normal;
    font-size: 12px;
    font-family: var(--font-family-inter);
    display: flex;
    align-items: center;
    position: relative;
}

.scl--prev-head-const-bread-sec-on h6 .span-bread {
    position: absolute;
    left: 20px;
    top: 2px;
}

.scl--prev-head-const-bread-sec-on h6 svg {
    position: absolute;
    left: 2px;
}

.scl--detail-info-preview-cnst-sty {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
}

.scl--item-prev-const-sty {
    display: flex;
    min-height: 32px;
    align-items: center;
}

.scl--singl-prev-const-sty.first-item {
    width: 462px;
}

.scl--singl-prev-const-sty {
    display: flex;
    align-items: center;
    min-height: 32px;
}

.scl--singl-prev-const-sty .span-class {
    width: 150px;
    font-size: 14px;
    color: var(--typography-text-body-secondary);
    font-family: var(--font-family-inter);
}

.scl--singl-prev-const-sty h6 {
    font-size: 14px;
    color: var(--typography-text-body-primary);
    font-family: var(--font-family-inter);
    font-weight: normal;
}

.scl--singl-prev-const-sty h6::first-letter {
    text-transform: uppercase;
}

.scl--prev-head-btn-update-sty {
    display: flex;
}

.scl--prev-head-btn-update-sty .btn-section-two {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 1);
    cursor: pointer;
    transition: all 0.1s;
    border: none;
}

.scl--prev-head-btn-update-sty .btn-section-two svg path {
    stroke: rgba(138, 139, 143, 0.5);
}

.scl--prev-head-btn-update-sty .btn-section-two:active svg path,
.scl--prev-head-btn-update-sty .btn-section-two:hover svg path {
    stroke: rgba(0, 0, 0, 0.8);
}

.scl--prev-head-btn-update-sty .btn-section-two:active {
    border: 1px solid rgba(142, 142, 147, 1);
    box-shadow:
        0 0 0 2px white,
        0 0 0 4px #2767d2;
}

.scl--singl-prev-const-sty .status-item {
    width: 120px;
}

.scl--singl-prev-const-sty .status-item .scl--cms-components-selectField-wrapper {
    padding: 0px 7px;
}

.scl--singl-prev-const-sty .scl--components-date-input {
    width: 286px;
}

.scl--title-prev-cnst-sty {
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(225, 228, 237, 1);
    margin-top: 10px;
}

.scl--title-prev-cnst-sty h6 {
    font-size: 20px;
    font-family: var(--font-family-inter);
    font-weight: bold;
}

.scl--title-prev-cnst-sty h6::first-letter {
    text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/workflow/css/preview-header.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,eAAe;IACf,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;IACxC;;yBAEqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".scl--prev-head-main-container h6 {\n    margin: 0;\n}\n\n.scl--prev-head-const-bread-sec-on {\n    width: 100%;\n    height: 21px;\n    display: flex;\n    gap: 3px;\n}\n\n.scl--prev-head-const-bread-sec-on button {\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 5px\n}\n\n.scl--prev-head-const-bread-sec-on span {\n    color: rgba(138, 139, 143, 1);\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n}\n\n.scl--prev-head-const-bread-sec-on h6 {\n    color: rgba(138, 139, 143, 1);\n    font-weight: normal;\n    font-size: 12px;\n    font-family: var(--font-family-inter);\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.scl--prev-head-const-bread-sec-on h6 .span-bread {\n    position: absolute;\n    left: 20px;\n    top: 2px;\n}\n\n.scl--prev-head-const-bread-sec-on h6 svg {\n    position: absolute;\n    left: 2px;\n}\n\n.scl--detail-info-preview-cnst-sty {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 15px;\n}\n\n.scl--item-prev-const-sty {\n    display: flex;\n    min-height: 32px;\n    align-items: center;\n}\n\n.scl--singl-prev-const-sty.first-item {\n    width: 462px;\n}\n\n.scl--singl-prev-const-sty {\n    display: flex;\n    align-items: center;\n    min-height: 32px;\n}\n\n.scl--singl-prev-const-sty .span-class {\n    width: 150px;\n    font-size: 14px;\n    color: var(--typography-text-body-secondary);\n    font-family: var(--font-family-inter);\n}\n\n.scl--singl-prev-const-sty h6 {\n    font-size: 14px;\n    color: var(--typography-text-body-primary);\n    font-family: var(--font-family-inter);\n    font-weight: normal;\n}\n\n.scl--singl-prev-const-sty h6::first-letter {\n    text-transform: uppercase;\n}\n\n.scl--prev-head-btn-update-sty {\n    display: flex;\n}\n\n.scl--prev-head-btn-update-sty .btn-section-two {\n    width: 30px;\n    height: 30px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(255, 255, 255, 1);\n    cursor: pointer;\n    transition: all 0.1s;\n    border: none;\n}\n\n.scl--prev-head-btn-update-sty .btn-section-two svg path {\n    stroke: rgba(138, 139, 143, 0.5);\n}\n\n.scl--prev-head-btn-update-sty .btn-section-two:active svg path,\n.scl--prev-head-btn-update-sty .btn-section-two:hover svg path {\n    stroke: rgba(0, 0, 0, 0.8);\n}\n\n.scl--prev-head-btn-update-sty .btn-section-two:active {\n    border: 1px solid rgba(142, 142, 147, 1);\n    box-shadow:\n        0 0 0 2px white,\n        0 0 0 4px #2767d2;\n}\n\n.scl--singl-prev-const-sty .status-item {\n    width: 120px;\n}\n\n.scl--singl-prev-const-sty .status-item .scl--cms-components-selectField-wrapper {\n    padding: 0px 7px;\n}\n\n.scl--singl-prev-const-sty .scl--components-date-input {\n    width: 286px;\n}\n\n.scl--title-prev-cnst-sty {\n    width: 100%;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid rgba(225, 228, 237, 1);\n    margin-top: 10px;\n}\n\n.scl--title-prev-cnst-sty h6 {\n    font-size: 20px;\n    font-family: var(--font-family-inter);\n    font-weight: bold;\n}\n\n.scl--title-prev-cnst-sty h6::first-letter {\n    text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
